import { render, staticRenderFns } from "./BaseFiltered.vue?vue&type=template&id=ccc88306&"
import script from "./BaseFiltered.vue?vue&type=script&lang=ts&"
export * from "./BaseFiltered.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports